<div class="container-fluid p-3">

  <div class="bg-white rounded-md border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex gap-3">
        <div class="flex-1">
          <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
            {{stepDetails?.name}}<span *ngIf=" stepDetails?.step_mapping?.scheme?.code === 'makeiii'">
    (SHQ, DDP, HQIDS, DISB, ADG (Acq/Tech), services (ICG, IA, IAF))
  </span>

          </h4>
          <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
            [{{ proposalName }}]
          </h5>
        </div>
        <div>
          <span
            class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all"
            [ngClass]="{
              'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
              'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
              'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
              'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
            }">
            <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                'bg-slate-500': stepDetails?.step_status == 0,
                'bg-emerald-500': stepDetails?.step_status == 'approved',
                'bg-amber-500': stepDetails?.step_status == 'recommended',
                'bg-blue-500': stepDetails?.step_status == 'initiated'
              }"></span>
            {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
          </span>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">
        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <!-- External Agencies Document Upload Table -->
  <div class="bg-white rounded-md border border-gray-200 overflow-hidden">

    <!-- Table Header Bar -->
    <div class="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-blue-50">
      <div class="flex items-center gap-2">
        <i class="pi pi-file text-blue-700 text-lg"></i>
        <span class="font-bold text-blue-800 text-base">External Agency Comments &amp; Documents</span>
      </div>
      <span class="text-sm font-semibold text-gray-600">Total Count: {{ rows.length }}</span>
    </div>

    <!-- Count selector -->
    <div class="flex items-center gap-2 px-4 py-2 border-b border-gray-200 bg-white">
      <span class="text-sm font-semibold text-gray-700">Select Number of Documents (Optional)</span>
      <button (click)="decrementRows()"
        class="w-7 h-7 flex items-center justify-center border border-gray-400 rounded text-gray-700 hover:bg-gray-100 font-bold text-lg leading-none">−</button>
      <span class="w-8 text-center font-semibold text-gray-800 text-sm">{{ rows.length }}</span>
      <button (click)="incrementRows()"
        class="w-7 h-7 flex items-center justify-center border border-gray-400 rounded text-gray-700 hover:bg-gray-100 font-bold text-lg leading-none">+</button>
    </div>

    <!-- Responsive Table Wrapper -->
    <div class="overflow-x-auto">
      <table class="w-full border-collapse text-sm">
        <thead>
          <tr class="bg-blue-900 text-white text-xs font-bold uppercase">
            <th class="px-3 py-3 text-center whitespace-nowrap border-r border-blue-700">ACTIONS</th>
            <th class="px-3 py-3 text-center whitespace-nowrap border-r border-blue-700">S.NO.</th>
            <th class="px-3 py-3 text-center whitespace-nowrap border-r border-blue-700">
              <div class="flex items-center justify-center gap-1">
                NAME OF EXTERNAL AGENCY
                <button class="ml-1 w-6 h-6 bg-white rounded flex items-center justify-center">
                  <i class="pi pi-filter text-blue-900 text-xs"></i>
                </button>
              </div>
            </th>
            <th class="px-3 py-3 text-center whitespace-nowrap border-r border-blue-700">
              <div class="flex items-center justify-center gap-1">
                BRIEF DESCRIPTION
                <button class="ml-1 w-6 h-6 bg-white rounded flex items-center justify-center">
                  <i class="pi pi-filter text-blue-900 text-xs"></i>
                </button>
              </div>
            </th>
            <th class="px-3 py-3 text-center whitespace-nowrap border-r border-blue-700">
              <div class="flex items-center justify-center gap-1">
                DOCUMENT NUMBER
                <button class="ml-1 w-6 h-6 bg-white rounded flex items-center justify-center">
                  <i class="pi pi-filter text-blue-900 text-xs"></i>
                </button>
              </div>
            </th>
            <th class="px-3 py-3 text-center whitespace-nowrap border-r border-blue-700">
              <div class="flex items-center justify-center gap-1">
                DOCUMENT DATE
                <button class="ml-1 w-6 h-6 bg-white rounded flex items-center justify-center">
                  <i class="pi pi-filter text-blue-900 text-xs"></i>
                </button>
              </div>
            </th>
            <th class="px-3 py-3 text-center whitespace-nowrap border-r border-blue-700">
              <div class="flex items-center justify-center gap-1">
                UPLOAD DATE
                <button class="ml-1 w-6 h-6 bg-white rounded flex items-center justify-center">
                  <i class="pi pi-filter text-blue-900 text-xs"></i>
                </button>
              </div>
            </th>
            <th class="px-3 py-3 text-center whitespace-nowrap border-r border-blue-700">DOCUMENT UPLOAD</th>
            <th class="px-3 py-3 text-center whitespace-nowrap">DOWNLOAD DOCUMENT</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; let i = index"
            class="border-b border-gray-200"
            [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-blue-50'">

            <!-- ACTIONS -->
            <td class="px-3 py-2 text-center border-r border-gray-200">
              <ng-container *ngIf="row.id; else uploadAction">
                <div class="flex items-center justify-center gap-1">
                  <button (click)="editRow(row, i)"
                    class="w-8 h-8 border-2 border-blue-500 rounded flex items-center justify-center hover:bg-blue-50 text-blue-600">
                    <i class="pi pi-pencil text-xs"></i>
                  </button>
                  <button (click)="deleteRow(row, i)"
                    class="w-8 h-8 border-2 border-red-400 rounded flex items-center justify-center hover:bg-red-50 text-red-500">
                    <i class="pi pi-trash text-xs"></i>
                  </button>
                </div>
              </ng-container>
              <ng-template #uploadAction>
                <button
                  *ngIf="row.selectedFile"
                  (click)="uploadRow(row, i)"
                  class="inline-flex flex-col items-center justify-center w-16 h-10 border-2 border-blue-500 rounded text-blue-600 hover:bg-blue-50 disabled:opacity-50 text-xs font-semibold gap-0.5">
                  <i class="pi pi-upload text-sm"></i>
                  <span>Upload</span>
                </button>
                <span *ngIf="!row.selectedFile" class="text-gray-400 text-xs">—</span>
              </ng-template>
            </td>

            <!-- S.NO. -->
            <td class="px-3 py-2 text-center font-semibold text-gray-700 border-r border-gray-200">{{ i + 1 }}</td>

            <!-- NAME OF EXTERNAL AGENCY -->
            <td class="px-3 py-2 border-r border-gray-200">
              <input
                type="text"
                [(ngModel)]="row.name"
                [disabled]="row.id && !row.editing"
                placeholder="Enter agency name"
                class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-600" />
            </td>

            <!-- BRIEF DESCRIPTION -->
            <td class="px-3 py-2 border-r border-gray-200">
              <textarea
                [(ngModel)]="row.description"
                [disabled]="row.id && !row.editing"
                placeholder="Enter brief description..."
                rows="2"
                class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-500 resize-none disabled:bg-gray-50 disabled:text-gray-600"></textarea>
            </td>

            <!-- DOCUMENT NUMBER -->
            <td class="px-3 py-2 border-r border-gray-200">
              <input
                type="text"
                [(ngModel)]="row.document_number"
                [disabled]="row.id && !row.editing"
                placeholder="e.g. DOC-2026-001"
                class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-600" />
            </td>

            <!-- DOCUMENT DATE -->
            <td class="px-3 py-2 border-r border-gray-200">
              <input
                type="date"
                [(ngModel)]="row.document_date"
                [disabled]="row.id && !row.editing"
                class="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-600" />
            </td>

            <!-- UPLOAD DATE -->
            <td class="px-3 py-2 border-r border-gray-200">
              <input
                type="date"
                [(ngModel)]="row.upload_date"
                [disabled]="true"
                class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-gray-50 text-gray-600" />
            </td>

            <!-- DOCUMENT UPLOAD -->
            <td class="px-3 py-2 text-center border-r border-gray-200">
              <ng-container *ngIf="!row.id || row.editing">
                <label [for]="'file-' + i" class="cursor-pointer">
                  <div class="w-9 h-9 border border-gray-300 rounded flex items-center justify-center hover:bg-gray-50 mx-auto"
                    [ngClass]="row.selectedFile ? 'border-blue-500 bg-blue-50' : 'border-gray-300'">
                    <i class="pi pi-cloud-upload text-gray-400 text-base"
                      [ngClass]="row.selectedFile ? 'text-blue-500' : 'text-gray-400'"></i>
                  </div>
                  <input [id]="'file-' + i" type="file" class="hidden"
                    (change)="onFileSelected($event, row)" />
                </label>
                <div *ngIf="row.selectedFile" class="text-xs text-blue-600 mt-1 truncate max-w-[80px] mx-auto" [title]="row.selectedFile.name">
                  {{ row.selectedFile.name }}
                </div>
              </ng-container>
              <ng-container *ngIf="row.id && !row.editing">
                <div class="w-9 h-9 border border-gray-200 rounded flex items-center justify-center mx-auto bg-gray-50">
                  <i class="pi pi-file text-green-500 text-base"></i>
                </div>
              </ng-container>
            </td>

            <!-- DOWNLOAD DOCUMENT -->
            <td class="px-3 py-2 text-center">
              <ng-container *ngIf="row.id && row.file_url; else noDownload">
                <button (click)="downloadDocument(row)"
                  class="w-9 h-9 bg-blue-600 hover:bg-blue-700 text-white rounded flex items-center justify-center mx-auto transition-colors">
                  <i class="pi pi-download text-sm"></i>
                </button>
              </ng-container>
              <ng-template #noDownload>
                <span class="text-gray-400 text-lg font-bold">−</span>
              </ng-template>
            </td>

          </tr>

          <!-- Empty state -->
          <tr *ngIf="rows.length === 0">
            <td colspan="9" class="py-8 text-center text-gray-400 text-sm">No records found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>